import React from 'react';
import styled from 'styled-components';
import {Z_INDEXES, ComponentMStyling, COLORS, ComponentTextStyle, focusStyles} from '../styles';
import {defaultOnMouseDownHandler} from '../common';

const StyledSwitcherItem = styled.div`
  padding: 16px 25px;
  margin: 0 2px;

  display: flex;
  align-items: center;
  text-align: center;
  position: relative;

  ${ComponentMStyling(ComponentTextStyle.Regular, COLORS.neutral_600)}

  text-decoration: none;

  svg {
    margin-right: 16px;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 4px;
    top: 4px;
    bottom: 4px;
    width: 4px;
    background-color: transparent;
    border-radius: 2px;
  }

  &.active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    font-weight: bold;
    color: ${COLORS.neutral_800};

    &:after {
      background-color: ${COLORS.primary_500};
    }

    svg path {
      fill: ${COLORS.neutral_800};
    }
  }

  &.disabled {
    color: ${COLORS.neutral_300};
    background-color: ${COLORS.neutral_100};
  }

  &:hover:not(.disabled) {
    z-index: ${Z_INDEXES.hover};
    color: ${COLORS.primary_600};
    background-color: ${COLORS.primary_20};

    svg path {
      fill: ${COLORS.primary_600};
    }
  }

  &:active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    color: ${COLORS.primary_800};
    background-color: ${COLORS.primary_100};

    &:after {
      background-color: ${COLORS.primary_500};
    }

    svg path {
      fill: ${COLORS.primary_800};
    }
  }

  &:focus:not(.disabled) {
    ${focusStyles};
    
    outline-offset: -2px;
  }
`;

const A = styled.a``;

export interface SwitcherNavItem {
  label: string;
  url: string;
  disabled?: boolean;
  icon?: any;
  as?: any;
  testId?: string;
}

const SwitcherMenuItem = ({label, url, disabled, icon, as = A, testId}: SwitcherNavItem) => (
  <StyledSwitcherItem
    onClick={() => (window.location.href = url || '')}
    as={as}
    onMouseDown={defaultOnMouseDownHandler}
    href={url || ''}
    target="_parent"
    key={label}
    className={disabled ? 'disabled' : ''}
    data-testid={testId}>
    {!!icon && React.cloneElement(icon, {size: '24px', color: '#666666'})}
    {label}
  </StyledSwitcherItem>
);

export default SwitcherMenuItem;
